import { render, staticRenderFns } from "./NavMenuLink.vue?vue&type=template&id=a85b0af0&scoped=true&"
import script from "./NavMenuLink.vue?vue&type=script&lang=js&"
export * from "./NavMenuLink.vue?vue&type=script&lang=js&"
import style0 from "./NavMenuLink.vue?vue&type=style&index=0&id=a85b0af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85b0af0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemIcon,VListItemTitle})
